module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_11.78397b79.jpg";